import type { Dispatch, FC, SetStateAction } from "react";
import type { UseQueryResult } from "@tanstack/react-query";
import { CustomerType } from "../../constants/customerTypes";
import { Filter } from "./Filter";
import type {
  FilterOptionsParams,
  FilterValue,
  FilterValues,
  IFilterItem,
} from "../../services/api/models/Filter";
import type { IFilterOptions } from "../../services/api/models/FilterOptions";

interface FiltersBuilderProps {
  filters?: IFilterItem[];
  values: FilterValues;
  customerType?: CustomerType;
  useFilterOptions: (
    params: FilterOptionsParams
  ) => UseQueryResult<IFilterOptions, Error>;
  setFilters: Dispatch<SetStateAction<FilterValues>>;

  updateDefaultReady?: (key: string) => void;
}

const FiltersBuilder: FC<FiltersBuilderProps> = ({
  filters,
  values,
  customerType,
  useFilterOptions,
  setFilters,
  updateDefaultReady,
}) => {
  const handleFilterChange = (key: string, value: FilterValue) => {
    setFilters((old) => ({ ...old, [key]: value }));
  };

  return (filters || []).map((filter) => (
    <Filter
      key={filter.key}
      customerType={customerType}
      filter={filter}
      filters={values}
      setFilters={handleFilterChange}
      useFilterOptions={useFilterOptions}
      updateDefaultReady={updateDefaultReady}
    />
  ));
};

export { FiltersBuilder };
